import { Button, Card, Item, Message, Segment } from 'semantic-ui-react';
import Post from './Post';
import SearchPostsDetail from './SearchPostsDetail';

export const MailTemplateSection = ({ loading, title, section, formik, maxLength, header, logo, contentType }) => {
  const moveUp = (name, post) => {
    const items = [...formik.values[name]];
    const idx = items.indexOf(post);
    if (idx - 1 < 0) return;
    const temp = items[idx - 1];
    items[idx - 1] = post;
    items[idx] = temp;
    formik.setFieldValue(name, items);
  };

  const moveDown = (name, post) => {
    const items = [...formik.values[name]];
    const idx = items.indexOf(post);
    if (idx + 1 > items.length - 1) return;
    const temp = items[idx + 1];
    items[idx + 1] = post;
    items[idx] = temp;
    formik.setFieldValue(name, [...items]);
  };

  const isSeriesSection = () => header || logo;

  return (
    <Segment basic loading={loading} style={{ padding: 0 }}>
      <Card fluid>
        <Card.Content>
          <h5>{title}</h5>
        </Card.Content>
        {isSeriesSection() && (
          <Card.Content>
            <Item.Group>
              <Item>
                <Item.Image src={header} size="medium" />
              </Item>

              <Item>
                <Item.Image src={logo} size="medium" />
              </Item>
            </Item.Group>
          </Card.Content>
        )}
        <Card.Content>
          {formik.errors[section] && <Message content={formik.errors[section]} color="red" />}
          <Item.Group divided>
            {formik.values[section]?.map((post, idx) => (
              <Post
                key={idx}
                siteId={formik.values.siteId}
                post={post}
                sendDate={formik.values.sendDate}
                moveUp={() => moveUp(section, post)}
                moveDown={() => moveDown(section, post)}
                removeItem={() =>
                  formik.setFieldValue(section, [...formik.values[section]?.filter(i => i.id !== post.id)])
                }
                updatePost={updatedPost => formik.setFieldValue(`${section}[${idx}]`, updatedPost)}
              />
            ))}

            {formik.values[section]?.length < maxLength && (
              <Item>
                <SearchPostsDetail
                  siteId={formik.values.siteId}
                  contentType={contentType}
                  handleSelection={post => {
                    let newPost = { ...post };
                    if (logo) {
                      newPost = {
                        ...newPost,
                        logo,
                        header,
                        title,
                      };
                    }
                    formik.setFieldValue(section, [...formik.values[section], newPost]);
                  }}
                  site={formik.values.siteId}
                  trigger={<Button icon="plus" basic labelPosition="left" content="Add item" />}
                />
              </Item>
            )}
          </Item.Group>
        </Card.Content>
      </Card>
    </Segment>
  );
};
